import classes from './workRightTable.module.css';

import confirmSVG from 'assets/svg/button_on-01.svg';

import { useState, useContext, useEffect } from 'react';
import { address_server_short, COLORS, PUBLIC_ASSETS } from '../../../../config';
import { observer } from 'mobx-react-lite';
import Progress from 'rsuite/Progress';
import { StructureStore } from '../../../../store/context/StructureStore';
import Icon from '../../../../helpers/components/Icon';
import DropdownComponent from '../../../Widgets/Dropdown/DropdownComponent';
import UserFieldsRenderer from '../../../UserFieldsRenderer/index';

const settingFilter = (setting) => {
  return setting?.length
    ? setting.reduce((acc, item) => {
        acc[item.param] = item.value;
        return acc;
      }, {})
    : setting;
};

const WorkRightTableRowItem = observer(
  ({
    item,
    params,
    rowsItem,
    selectItem,
    selectedItemsToPrint,
    selectedItemsToImport,
    mode,
    fromOther = false,
    imagePopup,
    typePackItems,
    changeTypePack,
    index,
    selectClick,
  }) => {
    const manualStore = useContext(StructureStore);

    const type = item.type;
    const value = item.value;
    const [barcode, setBarcode] = useState('');
    const newSetting = settingFilter(item.setting);
    const settings = item.settings;

    const commonProps = {
      item,
      fromOther,
      mode,
      rowsItem,
      selectItem,
      selectedItemsToPrint,
    };

    useEffect(() => {
      if (type === 'barcode') {
        const loadBarcodes = async () => {
          if (!manualStore.barcodes.length) {
            await manualStore.setBarcodes();
          }
          setBarcode(manualStore.barcodes?.find((i) => i.id === parseInt(value)));
        };
        loadBarcodes();
      }
    }, []);

    return (
      <td className={classes.workRightTableItem} onClick={imagePopup}>
        <UserFieldsRenderer type={type} forTable={true} {...commonProps} />
        {type === 'type_pack' && item.value != undefined && (
          <div className={classes.selectType}>
            <DropdownComponent
              keyItem={'id'}
              valueItem={'name'}
              items={typePackItems}
              selectedKey={value}
              label={'Тип штатива...'}
              onChange={(val) => {
                changeTypePack(val, index);
              }}
            />
          </div>
        )}
        {type === 'selectToImport' && (
          <div
            className={classes.deviceTrue + ' ' + (true ? classes.deviceTrueSelected : '')}
            onClick={() => {
              selectClick({ id: rowsItem.id });
            }}
          >
            {selectedItemsToImport?.find((val) => val.id == rowsItem.id) && (
              <Icon color={COLORS.color_hover2} src={confirmSVG} width={'17px'} height={'17px'} />
            )}
          </div>
        )}
        {type === 'progress' && value !== '' ? (
          <div className={classes.workRightTableItemString}>
            <Progress
              percent={value != undefined ? parseFloat(value) : 0}
              strokeColor={newSetting?.color ?? COLORS.color_brand}
              strokeWidth={22}
              showInfo={newSetting?.percentVisible || false}
            />
          </div>
        ) : (
          ''
        )}
        {type === 'select_check' && (
          <div className={classes.workRightTableItemCount}>{params?.items?.replace(',', ', ')}</div>
        )}
        {type === 'finance' && value !== '' ? (
          <div
            className={classes.workRightTableItemCount}
          >{`${value ? value + ' ' + item?.setting?.postfix : ''}`}</div>
        ) : (
          ''
        )}
        {type === 'yes_no' &&
          (value !== '' ? (
            value === 'yes' ? (
              <div style={{ color: 'green' }}>Да </div>
            ) : (
              <div>Нет</div>
            )
          ) : (
            ''
          ))}
        {type === 'file' &&
          (Array.isArray(params) ? (
            params?.map((file) => {
              return (
                <div className={classes.workRightTableItemString}>
                  <a href={`${address_server_short}${file}`} target={'_blank'} rel="noreferrer">
                    {' '}
                    {file.split('/').pop()}{' '}
                  </a>
                </div>
              );
            })
          ) : !!value && value != '' && typeof value == 'string' ? (
            <div className={classes.workRightTableItemString}>
              <a href={`${address_server_short}${value}`} target={'_blank'} rel="noreferrer">
                {' '}
                {value.split('/').pop()}{' '}
              </a>
            </div>
          ) : (
            ''
          ))}
        {type === 'barcode' && params?.value ? (
          <div>
            ({barcode?.name}) {params?.value}
          </div>
        ) : (
          ''
        )}
        {type === 'image' &&
          (Array.isArray(params) ? (
            params?.map((imagePath) => {
              return (
                <img
                  src={address_server_short + imagePath}
                  alt={'img'}
                  className={classes.workRightTable_Image}
                />
              );
            })
          ) : value ? (
            <img
              src={address_server_short + value}
              alt={'img'}
              className={classes.workRightTable_Image}
            />
          ) : (
            ''
          ))}
        {type === 'icon' &&
          (rowsItem?.setting && rowsItem?.setting[item.name]?.file ? (
            <img
              src={address_server_short + PUBLIC_ASSETS + rowsItem?.setting[item.name]?.file}
              alt={`${rowsItem?.setting[item.name]?.file}`}
              className={classes.workRightTable_icon}
            />
          ) : (
            ''
          ))}
        {type === 'icon' &&
          (rowsItem?.value[`user_field[${item.name}]`]?.setting?.file ? (
            <img
              src={
                address_server_short +
                PUBLIC_ASSETS +
                rowsItem?.value[`user_field[${item.name}]`]?.setting?.file
              }
              alt={`${rowsItem?.setting[item.name]?.file}`}
              className={classes.workRightTable_icon}
            />
          ) : (
            ''
          ))}
        {type === 'array' && (
          <div className={classes.workRightTableItemArray}>
            {value?.map((i) => (
              <div key={i.name}>{i.name}</div>
            ))}
          </div>
        )}
      </td>
    );
  },
);

export default WorkRightTableRowItem;
